var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextFont(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 28.287,
    viewBox: "0 0 42 28.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text-font",
    transform: "translate(0 -81.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M16.649,83.311a3.274,3.274,0,0,0-3.128-2.306H9.966a3.276,3.276,0,0,0-3.133,2.319l-6.7,21.911a3.14,3.14,0,1,0,6.028,1.757l1.377-4.961h8.1l1.482,4.93a3.276,3.276,0,1,0,6.265-1.915ZM8.466,97.247l1.677-6c.461-1.637.883-3.776,1.3-5.455h.08c.421,1.68.928,3.777,1.429,5.455l1.763,6Z",
    fill: "#4397d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M331.552,220.8v-5.843c0-3.951-1.788-7.251-7.392-7.251a15.225,15.225,0,0,0-5.072.831,1.685,1.685,0,0,0-1.056,2.05l.017.056a1.714,1.714,0,0,0,2.2,1.152,9.576,9.576,0,0,1,2.989-.515c2.578,0,3.06,1.272,3.06,2.165v.241c-5.947-.035-9.864,2.061-9.864,6.426a5.151,5.151,0,0,0,5.432,5.155,6.056,6.056,0,0,0,4.81-2.063h.1l.135.735a1.161,1.161,0,0,0,1.141.95h2.435a1.161,1.161,0,0,0,1.158-1.248C331.578,222.818,331.552,221.825,331.552,220.8Zm-5.089-2.028a3.67,3.67,0,0,1-.1.893,2.852,2.852,0,0,1-2.715,1.924,1.876,1.876,0,0,1-2.062-1.993c0-2.028,2.132-2.68,4.88-2.647Z",
    transform: "translate(-289.645 -115.98)",
    fill: "#4397d2"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFont);
export default __webpack_public_path__ + "static/media/text-font.29f6fd9df3630d9be8777ff2851c150d.svg";
export { ForwardRef as ReactComponent };